/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemLevelSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  id: z.int(),
  level: z.int(),
  name: z.string(),
  organizationId: z.string(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
